<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="visitForm" label-width="auto" label-position="right">
      <el-form-item label="回访项目：">
        {{visitForm.name}}
      </el-form-item>
      <el-form-item label="回访人：">
        <el-select v-model="visitAdminId" placeholder="请选择回访人" class="select-item">
          <el-option v-for="item in visitAdminIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回访满意度：">
        <el-select v-model="satisfaction" placeholder="请选择回访满意度" class="select-item">
          <el-option v-for="item in satisfactionArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题反馈：">
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="visitForm.problem" placeholder="请简单描述客户反馈的问题（非必填）" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {listShopStaff, updateVisitState} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      visitForm: this.value.visitForm,
      shopId: this.value.shopId,
      idx: this.value.ids,
      satisfaction: this.value.visitForm.satisfaction?this.value.visitForm.satisfaction:'',
      satisfactionArray: [
        {label: '不满意', value: 1},
        {label: '一般', value: 2},
        {label: '满意', value: 3},
        {label: '未回复', value: 4}
      ],

      visitAdminIdArray: [],
      visitAdminId: this.value.visitForm.visitAdminId?this.value.visitForm.visitAdminId:'',
    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },

    summit() {
      // console.log(this.idx)
      if(!this.visitAdminId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择回访人',
          type: 'warning'
        });
        return false
      }
      if(!this.satisfaction) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择回访满意度',
          type: 'warning'
        });
        return false
      }
      let arr = []
      arr.push(this.visitForm.id)
      let param = {}
      param['idArr'] = arr
      param['visitAdminId'] = this.visitAdminId;
      param['satisfaction'] = this.satisfaction;
      param['problem'] = this.visitForm.problem;
      postFormData(updateVisitState, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getShopAdmin() {
      this.visitAdminIdArray = []
      getFormData(listShopStaff, {id: this.shopId}).then(data => {
        this.visitAdminIdArray = this.visitAdminIdArray.concat(data.data)
      })
    },


  },
  mounted() {
    this.getShopAdmin()
    // if(this.idx > -1) {
    //   this.visitForm.petBreedArr.forEach(item => {
    //     item.show = false
    //   })
    // }
  }
}
</script>

<style scoped>

</style>
